import { Check } from "lucide-react";
import { useSeo } from "../hooks/useSeo";
import { EmailCapture } from "../components/EmailCapture";

const perks = [
  "New copy-and-paste AI setups the moment they drop",
  "Plain-English explanations — no jargon, ever",
  "First look at anything I build for the channel",
];

export default function Subscribe() {
  useSeo({
    title: "Get the free AI setups — Practical AI for Everyday Life",
    description: "Join the list and get free, plain-English AI setups delivered as I make them.",
  });

  return (
    <section className="bg-plexus min-h-[calc(100vh-68px)]" data-testid="subscribe-page">
      <div className="container-brand grid items-center gap-12 py-20 md:grid-cols-2">
        <div>
          <p className="eyebrow !text-ochre-bright">Free newsletter</p>
          <h1 className="mt-4 text-4xl text-bone sm:text-5xl">Get the setups before everyone else.</h1>
          <ul className="mt-8 space-y-4">
            {perks.map((p) => (
              <li key={p} className="flex items-start gap-3 text-on-navy-body">
                <span className="mt-0.5 grid h-6 w-6 shrink-0 place-items-center rounded-full bg-teal text-bone"><Check size={14} /></span>
                <span className="text-[17px]">{p}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="brand-card p-8">
          <EmailCapture
            source="subscribe-page"
            heading="Join the list"
            sub="No spam. Unsubscribe in one click, anytime."
            redirectToThankYou
          />
        </div>
      </div>
    </section>
  );
}
